<template>
	<v-dialog :fullscreen="isMobile" v-if="open" v-model="open" max-width="700px" scrollable>
		<v-card raised>
			<v-card-title>
				<button type="button" class="btn-flat-icon--dark" @click="open=false">
					<v-icon medium flat>fal fa-times</v-icon>
				</button>
			</v-card-title>
			<v-card-text class="pt-0 event-page__modal-card-text">
				<div>
					<p class="event-page__modal-heading">Contact {{ host.first_name }}</p>
					<v-divider class="mt-3 mb-3"></v-divider>
					<form>
						<v-text-field
							color="link"
							v-model="phone"
							label="Phone Number"
							:rules="phoneRules"
							validate-on-blur
						></v-text-field>
						<v-text-field
							color="link"
							v-model="city"
							label="City &amp; State"
							:rules="cityRules"
							validate-on-blur
						></v-text-field>
						<v-textarea
							color="link"
							v-model="contactHostMessage"
							label="Message"
							rows="5"
							required
							validate-on-blur
						></v-textarea>
					</form>
				</div>
				<div style="display: flex; flex-direction: row; justify-content: flex-end;">
					<v-btn class="btn-blue" @click="sendContactHostEmail">Send Message</v-btn>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
export default {
	name: 'eventContactHostModal',
	data() {
		return {
			phone: '',
			city: '',
			contactHostMessage: '',
			phoneRules: [
				v =>
					/(\+?\d{1,2}\s?.?-?)?\(?\d{3}\)?[\s-.]?\d{3}[\s-.]?\d{4}\b/.test(v) ||
					'Please enter a valid phone number'
			],
			cityRules: [v => v.length <= 20 || 'City must be less than 20 characters']
		}
	},
	methods: {
		...mapActions(['setModalOpen', 'setSnackbarText', 'setSnackbarOpen']),
		sendContactHostEmail() {
			axios
				.post('/api/v1/contact/', {
					name: this.user.first_name + ' ' + this.user.last_name,
					subject: 'Inquiry from member about ' + this.event.title,
					event: this.event.pk,
					recipient: this.host.uuid,
					message: this.contactHostMessage,
					email: this.user.email,
					phone: this.phone,
					city: this.city
				})
				.then(response => {
					this.resetContactModal()
					this.setSnackbarText('Message Sent!')
					this.setSnackbarOpen(true)
				})
		},
		resetContactModal() {
			this.open = false
			this.contactHostMessage = ''
		}
	},
	computed: {
		...mapGetters(['getModalProp', 'user']),
		host() {
			return this.event.host.user
		},
		open: {
			get() {
				return this.getModalProp('eventContactHostModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'eventContactHostModal', value: val })
			}
		},
		event() {
			return this.getModalProp('eventModalEvent')
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		}
	}
}
</script>
